export default __webpack_public_path__ + "static/media/not-found.7de83acd.png";